import { ROUTE_BOOKING_PAGE } from '@/constants/routes';
import { Box, Text } from '@chakra-ui/layout';
import { Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useContent from './useContent';

interface IContentProps {
	isPreviewEnabled: boolean;
	togglePreview: () => void;
}

export default function Content(props: IContentProps) {
	const { id } = useContent();

	return (
		<Box
			display={{
				base: props.isPreviewEnabled ? 'block' : 'none',
				md: 'block',
			}}
			m={{
				base: 4,
				md: 4,
			}}
			borderRadius="md"
			mt={{
				base: 4,
				md: 8,
			}}
			pb={{
				base: 0,
				md: 4,
			}}
			pr={{
				base: 0,
				md: 4,
			}}
			overflow="auto"
			position="relative"
		>
			<Preview
				togglePreview={props.togglePreview}
				isPreviewEnabled={props.isPreviewEnabled}
				url={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', id)}
			/>
		</Box>
	);
}

function Preview(props: { url: string; isPreviewEnabled: boolean; togglePreview: () => void }) {
	return (
		<Box
			borderWidth={1}
			borderColor="gray.200"
			resize="both"
			minH="sm"
			minW="xs"
			maxW="100%"
			maxH="100%"
			borderRadius="md"
			overflow="hidden"
			boxShadow={{
				base: 'lg',
				sm: 'md',
			}}
			position="relative"
			backgroundColor="white"
			h="100%"
			display="grid"
			w="100%"
			gridTemplateRows="auto  1fr"
		>
			<OSXHeader />
			<Box
				id="booking-page-preview"
				as="iframe"
				margin="auto"
				transform={{
					base: 'scale(0.6)',
					sm: 'scale(0.6)',
					md: 'scale(0.5)',
					lg: 'scale(0.8)',
				}}
				width={{
					base: '166%',
					sm: '166%',
					md: '200%',
					lg: '125%',
				}}
				height={{
					base: '166%',
					sm: '166%',
					md: '200%',
					lg: '125%',
				}}
				transformOrigin="top left"
				src={props.url}
				title="Preview"
				frameBorder="0"
				overflow="hidden"
			/>
		</Box>
	);
}

function OSXHeader() {
	const { t } = useTranslation();
	return (
		<Box display="flex" alignItems="center" bg="gray.200" p="1" position="relative">
			<Tooltip label={t('This is how your customers will see your reservation calendar.')}>
				<Text cursor="help" flex="1" textAlign="center" fontWeight="600" fontSize="xs">
					{t('Reservation calendar preview')}
				</Text>
			</Tooltip>
		</Box>
	);
}
